import { ApiEnvironment } from '../../models/api-environment';

export class PlacesEnvironment extends ApiEnvironment {
  get placeSetsUrl() {
    return `${this.baseUrl}/places/v1/sets`;
  }

  placeSetsSetIdUrl(setId: string) {
    return `${this.baseUrl}/places/v1/sets/${setId}`;
  }

  placeSetPlacelistUrl(setId: string) {
    return `${this.baseUrl}/places/v1/sets/${setId}/placelist`;
  }

  placesPlacePlaceIdUrl(placeId: string) {
    return `${this.baseUrl}/places/v1/place/${placeId}`;
  }

  placesPlacePlaceIdDetailsUrl(placeId: string) {
    return `${this.baseUrl}/places/v1/place/${placeId}/details`;
  }

  get placesPlaceDetailsBulkUrl() {
    return `${this.baseUrl}/places/v1/place/details/bulk`;
  }

  override resolve(environment: unknown) {
    return environment instanceof PlacesEnvironment ? environment : this;
  }
}

export const placesEnvironment = new PlacesEnvironment();
